import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EditSquare"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.4974 5.68618C22.4974 6.08429 22.3392 6.46608 22.0575 6.74743L10.8075 17.9974H6V13.1899L17.25 1.93993C17.5314 1.65826 17.9131 1.5 18.3113 1.5C18.7094 1.5 19.0911 1.65826 19.3725 1.93993L22.0575 4.62493C22.3392 4.90628 22.4974 5.28807 22.4974 5.68618ZM21 5.68993L18.3075 2.99743L16.0575 5.24743L18.75 7.93993L21 5.68993ZM7.5 16.4974V13.8049L15 6.30493L17.6925 8.99744L10.1925 16.4974H7.5ZM3 22.4974H18C18.8284 22.4974 19.5 21.8259 19.5 20.9974V14.2474H18V20.9974H3V5.99743H9.75V4.49743H3C2.17157 4.49743 1.5 5.169 1.5 5.99743V20.9974C1.5 21.8259 2.17157 22.4974 3 22.4974Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EditSquare.vue"]]);
